import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step__basic" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Поиск по ИНН", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Введите ИНН, дождитесь загрузки (данные для юр лица заполнятся автоматически)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Выберите тип заявителя", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "В выпадающем списке ниже", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите ОГРНИП", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите ОГРН", -1)
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите КПП", -1)
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Юридический адрес", -1)
const _hoisted_15 = { class: "right" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите сокращённое название организации", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Пример: ООО \"ЮГ-СЕРВИСГРУПП\"", -1)
const _hoisted_19 = {
  key: 1,
  style: {"margin-bottom":"242px"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите полное название организации", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Пример: ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ \"ЮГ-СЕРВИСГРУПП\"", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "Введите ИНН",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document.client_inn) = $event)),
          maxlength: "12",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inn_change && _ctx.inn_change(...args))),
          onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inn_change && _ctx.inn_change(...args))),
          onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
        }, null, 544), [
          [_vModelText, _ctx.document.client_inn]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.client_type_title,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.client_type_title) = $event)),
          editable: "",
          options: _ctx.client_type_options,
          optionLabel: "name",
          placeholder: _ctx.client_type_default.name,
          style: {"width":"480px"},
          onChange: _ctx.client_type_change
        }, null, 8, ["modelValue", "options", "placeholder", "onChange"])
      ]),
      (_ctx.document.client_type == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Введите ОГРНИП",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.client_ogrnip) = $event)),
              maxlength: "15",
              onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
            }, null, 512), [
              [_vModelText, _ctx.document.client_ogrnip]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Введите ОГРН",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.document.client_ogrn) = $event)),
              maxlength: "13",
              onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
            }, null, 512), [
              [_vModelText, _ctx.document.client_ogrn]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Введите КПП",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.document.client_kpp) = $event)),
              maxlength: "9",
              onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
            }, null, 512), [
              [_vModelText, _ctx.document.client_kpp]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("textarea", {
              class: "input",
              type: "text",
              style: {"resize":"none","overflow":"hidden"},
              placeholder: "Введите юридический адрес",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.document.client_address) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.client_address]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.document.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Введите сокращённое название организации",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.document.client_smallname) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.client_smallname]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.document.client_type == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _hoisted_21,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Введите полное название организации",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.document.client_fullname) = $event))
            }, null, 512), [
              [_vModelText, _ctx.document.client_fullname]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}